import React, { useState, useEffect, useRef } from 'react';
import { useSwipeable } from 'react-swipeable';
import './Gallery.css';
import MUAY_THAI_CORNER from '../assets/MUAY_THAI_CORNER.png';
import POST_FIGHT_WINNER_COACHES_REFEREE from '../assets/POST_FIGHT_WINNER_COACHES_REFEREE.png';
import POST_FIGHT_WINNER_ALONE from '../assets/POST_FIGHT_WINNER_ALONE.png';
import postfight from '../assets/postfight.png';
import kbmt_gallery_image from '../assets/kbmt_gallery_image.png';
import kbmtgallery from '../assets/kbmtgallery.png';
import kbmtgalleryone from '../assets/kbmtgalleryone.png';
import kbmtgallerytwo from '../assets/kbmtgallerytwo.png';
import kbmtwinnerthai from '../assets/kbmtwinnerthai.png';
import kbmtwinnerthai2 from '../assets/kbmtwinnerthai2.png';
import kbmt_post_fight_corner_crew from '../assets/kbmt_post_fight_corner_crew.png';
import kbmt_group_picture from '../assets/kbmt_group_picture.png';
import kbmt_post_fight_never_alone from '../assets/kbmt_post_fight_never_alone.png';
import picturewinner from '../assets/picturewinner.png';
import postfightttwinn from '../assets/postfightttwinn.png';
import kbmthkt from '../assets/kbmthkt.png';
import postfightwin from '../assets/postfightwin.png';
import winnnerposing from '../assets/winnnerposing.png';
import winnerposing2 from '../assets/winnerposing2.png';
import posingwinner1 from '../assets/posingwinner1.png';
import posingwinnerrr from '../assets/posingwinnerrr.png';
import OratiaWin from '../assets/OratiaWin.png';
import OratiaPostFight from '../assets/OratiaPostFight.png';
import AFTER_FIGHT_GIRL from '../assets/AFTER_FIGHT_GIRL.png';
import BEFORE_FIGHT_GIRL from '../assets/BEFORE_FIGHT_GIRL.png';
import GROUP_IMAGE_POST from '../assets/GROUP_IMAGE_POST.png';
import GROUPPICTURE_KB from '../assets/GROUPPICTURE_KB.png';
import GROUPPICTURE_KB_FOUR from '../assets/GROUPPICTURE_KB_FOUR.png';
import GROUPPICTURE_KB_ONE from '../assets/GROUPPICTURE_KB_ONE.png';
import GROUPPICTURE_KB_THREE from '../assets/GROUPPICTURE_KB_THREE.png';
import GROUPPICTURE_KB_TWO from '../assets/GROUPPICTURE_KB_TWO.png';
import POST_FIGHT_GROUPPICTURE from '../assets/POST_FIGHT_GROUPPICTURE.png';
import POST_FIGHT_WINNER_OR from '../assets/POST_FIGHT_WINNER_OR.png';
import POSTFIGHT_HEAVY_WINNERS from '../assets/POSTFIGHT_HEAVY_WINNERS.png';
import POSTFIGHT_POSING_WINNERS from '../assets/POSTFIGHT_POSING_WINNERS.png';
import POSTFIGHT_SCARFACE from '../assets/POSTFIGHT_SCARFACE.png';
import POSTFIGHT_WINNER_OR from '../assets/POSTFIGHT_WINNER_OR.png';

function Gallery() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showOverview, setShowOverview] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const galleryRef = useRef(null);
    const autoScrollRef = useRef(null);
    const resumeScrollTimeoutRef = useRef(null);

    const images = [
        BEFORE_FIGHT_GIRL,
        GROUP_IMAGE_POST,
        GROUPPICTURE_KB,
        GROUPPICTURE_KB_ONE,
        GROUPPICTURE_KB_TWO,
        GROUPPICTURE_KB_THREE,
        GROUPPICTURE_KB_FOUR,
        POST_FIGHT_GROUPPICTURE,
        POST_FIGHT_WINNER_OR,
        POSTFIGHT_WINNER_OR,
        POSTFIGHT_HEAVY_WINNERS,
        POSTFIGHT_POSING_WINNERS,
        POSTFIGHT_SCARFACE,
        // ✅ OLD IMAGES (unchanged)
        AFTER_FIGHT_GIRL,
        OratiaPostFight,
        OratiaWin,
        winnnerposing,
        winnerposing2,
        posingwinnerrr,
        posingwinner1,
        postfightwin,
        kbmthkt,
        postfightttwinn,
        picturewinner,
        kbmt_post_fight_never_alone,
        kbmt_group_picture,
        kbmt_post_fight_corner_crew,
        kbmtwinnerthai2,
        kbmtwinnerthai,
        postfight,
        kbmt_gallery_image,
        kbmtgallery,
        kbmtgalleryone,
        kbmtgallerytwo,
        MUAY_THAI_CORNER,
        POST_FIGHT_WINNER_COACHES_REFEREE,
        POST_FIGHT_WINNER_ALONE
    ];

    // Pagination settings
    const THUMBNAILS_PER_PAGE = 7;
    const totalPages = Math.ceil(images.length / THUMBNAILS_PER_PAGE);
    const startIndex = currentPage * THUMBNAILS_PER_PAGE;
    const endIndex = startIndex + THUMBNAILS_PER_PAGE;
    const currentThumbnails = images.slice(startIndex, endIndex);

    const startAutoScroll = () => {
        autoScrollRef.current = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % images.length);
        }, 3000);
    };

    const stopAutoScroll = () => {
        clearInterval(autoScrollRef.current);
    };

    useEffect(() => {
        startAutoScroll();
        return () => {
            stopAutoScroll();
            clearTimeout(resumeScrollTimeoutRef.current);
        };
    }, []);

    const handlers = useSwipeable({
        onSwipedLeft: () => setCurrentIndex((prev) => (prev + 1) % images.length),
        onSwipedRight: () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length),
        trackMouse: true,
    });

    const handleThumbnailClick = (index) => {
        setCurrentIndex(index);

        // Pause auto-scroll and resume after 5s
        stopAutoScroll();
        clearTimeout(resumeScrollTimeoutRef.current);
        resumeScrollTimeoutRef.current = setTimeout(() => {
            startAutoScroll();
        }, 5000);

        // Scroll to gallery (4rem higher)
        if (galleryRef.current) {
            const y = galleryRef.current.getBoundingClientRect().top + window.scrollY - 170; // 4rem = 64px
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    const translateValue = `-${100 * currentIndex}%`;

    return (
        <div className="Gallery-wrapper">
            <button className="Overview-toggle-btn" onClick={() => setShowOverview(!showOverview)}>
                {showOverview ? 'Hide Overview' : 'Show Overview'}
            </button>

            {showOverview && (
                <div className="Gallery-overview">
                    <h2>Post-Fight Highlights & Victories</h2>
                    <p>
                        A visual journey capturing intense moments from the ring, post-fight embraces,
                        and proud winners standing tall. Relive the passion, dedication, and celebration of our athletes
                        and teams through this curated image collection.
                    </p>

                    <div className="Thumbnail-grid">
                        {currentThumbnails.map((img, index) => {
                            const globalIndex = startIndex + index;
                            return (
                                <img
                                    key={globalIndex}
                                    src={img}
                                    alt={`Thumb ${globalIndex + 1}`}
                                    className={`Thumbnail ${globalIndex === currentIndex ? 'active' : ''}`}
                                    onClick={() => handleThumbnailClick(globalIndex)}
                                />
                            );
                        })}
                    </div>

                    {/* Pagination Controls */}
                    <div className="Pagination-controls">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 0}
                            className="Pagination-btn"
                        >
                            Previous
                        </button>

                        <span className="Pagination-info">
                            Page {currentPage + 1} of {totalPages}
                        </span>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages - 1}
                            className="Pagination-btn"
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}

            <div className="Gallery" {...handlers} ref={galleryRef}>
                <div className="Gallery-inner" style={{ transform: `translateX(${translateValue})` }}>
                    {images.map((image, index) => (
                        <div key={index} className="Image-outer">
                            <img src={image} alt={`Gallery image ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Gallery;